<app-page-shell variant="default">
<div class="card card-box mb-5">
      <div class="card-header py-3">
        <div class="card-header--title font-size-lg">
          Manage Campaigns
        </div>
        <div class="card-header--actions">
          <button class="btn btn-sm btn-primary pull-right" type="button"
                  routerLink="/{{routes.createCampaign({projectId: projectId})}}" role="button">
            <span class="btn-wrapper--icon"><i class="fa fa-plus"></i></span>
            <span class="btn-wrapper--label">Start a Campaign</span>
          </button>
        </div>
      </div>
      <div class="p-3">
        <app-sb-table
          [rows]="campaigns()"
          [totalRows]="totalRows()"
          [columns]="tableColumns"
          [options]="tableOptions"
          [viewMode]="viewType === 'card' ? 'card' : 'list'"
          (stateChange)="onTableState($event)">

          <div class="row py-3 m-0" sbTableToolbar>
            <div class="col-md-4 d-flex align-items-center justify-content-start">
              <div class="client-dropdown">
                <app-creatable-select
                  [hideLabel]="true" [isCreatable]="false" [onlyBottomBorder]="false"
                  [placeholder]="'Select influencer type'" [selectOptions]="influencerTypes()"
                  (optionSelected)="influencerType = $event ? $event.value : 'all';
                 filterCampaignsByInfluencerType($event ? $event.value : 'all')"></app-creatable-select>
              </div>
            </div>
            <div class="col-md-8 d-flex align-items-center justify-content-end">
              <a class="filters" [class.active-status]="selectedStatus === 'all'" (click)="filterCampaignsByStatus('all')">
                All
              </a>
              <a class="filters" [class.active-status]="selectedStatus === 'launched'" (click)="filterCampaignsByStatus('launched')">
                Active
              </a>
              <a class="filter-last" [class.active-status]="selectedStatus === 'draft'" (click)="filterCampaignsByStatus('draft')">
                Draft
              </a>
              <button type="button" [class]="{'active-btn': viewType === 'card', 'inactive-btn': viewType !== 'card'}" class="btn btn-default btn-sm list-button ms-4" (click)="changeViewType('card')">
                <i class="fa fa-th-large me-1"></i>
                Card
              </button>
              <button type="button" [class]="{'active-btn': viewType === 'list', 'inactive-btn': viewType !== 'list'}" class="btn btn-default btn-sm card-button" (click)="changeViewType('list')">
                <i class="fa fa-th-list me-1"></i>
                List
              </button>
            </div>
          </div>

          <ng-template sbTableCell="name" let-campaign>
            <a class="cursor-pointer campaign-name-link"
               [routerLink]="'/'+routes.addInfluencers({projectId: projectId})"
               [queryParams]="{campId: campaign.id}">
              {{campaign.name}}
            </a>
            @if (campaign.created_by || campaign.updated_by) {
              <app-info-popover container="body" info="{{getCampaignUpdateInfo(campaign)}}" ></app-info-popover>
            }
            <div class="d-block" >
              <small>{{campaign.code}}</small>
              @if (campaign.launched_at && campaign.status === 'launched') {
              <small
                     class="campaign-launch-history-link"
                     [class.cursor-pointer]="campaign.last_launched_at && currentUser()?.can('launchHistory', 'campaign')"
                     (click)="campaign.last_launched_at && currentUser()?.can('launchHistory', 'campaign') && openCampaignLaunchHistory(campaign, $event)">
                - Launched {{campaign.launch_user ? 'by' : 'at'}} {{$safeNavigationMigration(campaign.launch_user?.first_name) | titlecase}} {{$safeNavigationMigration(campaign.launch_user?.last_name) | titlecase}}
                - {{smartDateFormat($safeNavigationMigration(campaign?.launched_at))}}
                @if (campaign.last_launched_at && currentUser()?.can('launchHistory', 'campaign')) {
                <i
                   class="fa fa-history campaign-launch-history-icon" title="Launch History"></i>
                }
                @if (campaign.timezone || project()?.timezone) {
                <app-info-popover container="body"
                                  info="{{getDateTimeBasedOnCampaign(campaign, project())}}"></app-info-popover>
                }
              </small>
              }
              @if (!(campaign.launched_at && campaign.status === 'launched') && campaign.last_launched_at) {
              <small
                     class="campaign-launch-history-link"
                     [class.cursor-pointer]="currentUser()?.can('launchHistory', 'campaign')"
                     (click)="currentUser()?.can('launchHistory', 'campaign') && openCampaignLaunchHistory(campaign, $event)">
                - Previously launched at {{smartDateFormat($safeNavigationMigration(campaign?.last_launched_at))}}
                @if (currentUser()?.can('launchHistory', 'campaign')) {
                <i class="fa fa-history campaign-launch-history-icon" title="Launch History"></i>
                }
              </small>
              }
              @if (!(campaign.launched_at && campaign.status === 'launched') && !campaign.last_launched_at && campaign.status !== 'draft' && currentUser()?.can('launchHistory', 'campaign')) {
              <small
                     class="campaign-launch-history-link cursor-pointer"
                     (click)="openCampaignLaunchHistory(campaign, $event)">
                <i class="fa fa-history campaign-launch-history-icon" title="Launch History"></i>
              </small>
              }
            </div>
          </ng-template>

          <ng-template sbTableCell="designs" let-campaign>
            @for (design of designTypes; track design) {
              @if (campaign.designs?.[design.key]; as url) {
              <app-sb-image-preview [hidden]="brokenDesigns.has(url)"
                                    [src]="url" [alt]="campaign.name + ' - ' + design.label" [caption]="design.label"
                                    [previewTitle]="campaign.name + ' - ' + design.label"
                                    (loadError)="brokenDesigns.add(url)"></app-sb-image-preview>
              }
            }
            @if (!hasDesigns(campaign)) {
            <span>-</span>
            }
          </ng-template>

          <ng-template sbTableCell="influencers_count" let-campaign>
            <div [routerLink]="'/'+routes.addInfluencers({projectId: projectId})" [queryParams]="{campId: campaign.id}">
              {{campaign.influencers_count === 0 ? '-' : campaign.influencers_count}}
              @if ((campaign.influencers_count_possible_total_audience <= campaign.influencers_count && campaign.influencers_count_possible_receive_email <= 0) || isInfoOnly(campaign.status, campaign.launch_code)) {
              <app-info-popover container="body" [info]="campaign.influencers_count + 'Influencer were part of this campaign'"></app-info-popover>
              }
              @if ((campaign.influencers_count_possible_total_audience > campaign.influencers_count || campaign.influencers_count_possible_receive_email > 0) && isReLaunchable(campaign.status, campaign.launch_code)) {
              <app-re-launched-popover container="body" [newInfluencerCount]="campaign.influencers_count_possible_total_audience - campaign.influencers_count" [campaignEmailInfluencerCount]="campaign.influencers_count_possible_receive_email" [campaignId]="campaign.id" (IsClicked)="reLaunch($event)"></app-re-launched-popover>
              }
            </div>
          </ng-template>

          <ng-template sbTableCell="referrals" let-campaign>{{campaign.referrals === 0 ? '-': campaign.referrals}}</ng-template>

          <ng-template sbTableCell="social_shares" let-campaign>{{campaign.social_shares === 0 ? '-': campaign.social_shares}}</ng-template>

          <ng-template sbTableCell="open_rate" let-campaign>
            {{getEmailSendProgress(campaign)}}
            <app-info-popover container="body" info="{{getEmailSendProgressInfo(campaign)}}" ></app-info-popover>
          </ng-template>

          <ng-template sbTableCell="status" let-campaign>
            <app-campaign-status [campaign]="campaign" [projectId]="projectId" [currentUser]="currentUser()" [subscribeSocket]="false"></app-campaign-status>
          </ng-template>

          <ng-template sbTableCell="api_sync" let-campaign>
            <app-campaign-api-sync [campaign]="campaign"></app-campaign-api-sync>
          </ng-template>

          <ng-template sbTableCell="email_subject" let-campaign>{{campaign.email_subject}}</ng-template>

          <ng-template sbTableActions let-campaign>
            <button class="btn-icon float-end" mat-icon-button [matMenuTriggerFor]="menu"
                    aria-label="Example icon-button with a menu">
              <span class="fa fa-ellipsis-v"></span>
            </button>
            <mat-menu #menu="matMenu" class="campaign-popover">
              <a class="dropdown-item" (click)="openRenameModal(campaign)">
                <i class="fa fa-pencil me-2"></i>Rename
              </a>
              <a class="dropdown-item" [routerLink]="'/'+routes.addInfluencers({projectId: projectId})"
                 [queryParams]="{campId: campaign.id}">
                <i class="fa fa-list me-2" aria-hidden="true"></i>Manage Influencers</a>
              @if (campaign.segments.length > 0 && campaign.landing_page_status !== 'skipped') {
              <a class="dropdown-item" (click)="onEditCampaignTemplate(campaign)">
                <i class="fa fa-paint-brush me-2" aria-hidden="true"></i>
                {{campaign.template ? 'Edit' : 'Add'}} Landing Page</a>
              }
              @if (campaign.segments?.length > 0 && ((campaign.template && campaign.landing_page_status !== 'skipped') || campaign.landing_page_status === 'skipped' )) {
              <a class="dropdown-item" (click)="onEditCampaignShare(campaign)">
                <i class="fa fa-share me-2" aria-hidden="true"></i>Edit Share</a>
              }
              @if (campaign.segments?.length > 0 && ((campaign.template && campaign.landing_page_status !== 'skipped') || campaign.landing_page_status === 'skipped' )) {
              <a class="dropdown-item" (click)="onEditCampaignPreview(campaign)">
                <i class="fa fa-envelope me-2" aria-hidden="true"></i>Edit Email</a>
              }
              <a class="dropdown-item" (click)="copyCampaign(campaign.id)">
                <i class="fa fa-clipboard me-2"></i>Duplicate</a>
              @if (campaign.status!=='draft') {
              <a class="dropdown-item"
                 [routerLink]="'/'+routes.statisticsForCampaign({projectId: projectId}, {campaignId: campaign.id})"
                 [queryParams]="{campaignId: campaign.id}"><i class="fa fa-eye me-2"></i>View report</a>
              }
              <a class="dropdown-item" (click)="deleteCampaign(campaign.id)">
                <i class="fa fa-trash me-2"></i>Delete</a>
              @if (['launch_queued', 'launch_scheduled', 'in-progress', 'launching', 'launch_in_progress', 'temporarily-failed'].includes(campaign.status)) {
              <a class="dropdown-item" (click)="cancelLaunch(campaign.id)">
                <i class="fa fa-times-circle me-2" aria-hidden="true"></i>Cancel Launch</a>
              }
              @if (['launched', 'launch_failed'].includes(campaign.status)) {
              <a class="dropdown-item" (click)="reLaunch(campaign.id)">
                <i class="fa fa-rocket me-2" aria-hidden="true"></i>Re-Launch</a>
              }
              @if (['draft', 'launch_failed'].includes(campaign.status) && campaign.email_from_name && campaign.email_reply_to && campaign.email_subject) {
              <a class="dropdown-item"
                 (click)="launchCampaign(campaign.id)">
                <i class="fa fa-rocket me-2" aria-hidden="true"></i>Launch Page</a>
              }
              <a class="dropdown-item" [href]="campaign.share_guide_url" target="_blank">
                <i class="fa fa-book me-2" aria-hidden="true"></i>Setup Guide</a>
              @if (campaign.integration_instruction_url) {
              <a class="dropdown-item" [href]="campaign.integration_instruction_url" target="_blank">
                <i class="fa fa-code me-2" aria-hidden="true"></i>Widget Instructions</a>
              }
            </mat-menu>
          </ng-template>

          <ng-template sbTableCard let-campaign>
            <div class="campaign-card">
              <div class="w-100 popup-button-section">
                <button class="btn-icon float-end" mat-icon-button [matMenuTriggerFor]="menu"
                        aria-label="Example icon-button with a menu">
                  <span class="fa fa-ellipsis-v"></span>
                </button>
                <mat-menu #menu="matMenu" class="campaign-popover">
                  <a class="dropdown-item" (click)="openRenameModal(campaign)">
                    <i class="fa fa-pencil me-2"></i>Rename
                  </a>
                  <a class="dropdown-item" [routerLink]="'/'+routes.addInfluencers({projectId: projectId})" [queryParams]="{campId: campaign.id}">
                    <i class="fa fa-list me-2" aria-hidden="true"></i>Manage Influencers</a>
                  @if (campaign.segments.length > 0 && campaign.landing_page_status !== 'skipped') {
                  <a class="dropdown-item" (click)="onEditCampaignTemplate(campaign)">
                    <i class="fa fa-paint-brush me-2" aria-hidden="true"></i>{{campaign.template ? 'Edit' : 'Add'}} Landing Page</a>
                  }
                  @if (campaign.segments?.length > 0 && ((campaign.template && campaign.landing_page_status !== 'skipped') || campaign.landing_page_status === 'skipped' )) {
                  <a class="dropdown-item" (click)="onEditCampaignShare(campaign)">
                    <i class="fa fa-share me-2" aria-hidden="true"></i>Edit Share</a>
                  }
                  @if (campaign.segments?.length > 0 && ((campaign.template && campaign.landing_page_status !== 'skipped') || campaign.landing_page_status === 'skipped' )) {
                  <a class="dropdown-item" (click)="onEditCampaignPreview(campaign)">
                    <i class="fa fa-envelope me-2" aria-hidden="true"></i>Edit Email</a>
                  }
                  <a class="dropdown-item" (click)="copyCampaign(campaign.id)">
                    <i class="fa fa-clipboard me-2"></i>Duplicate</a>
                  @if (campaign.status!=='draft') {
                  <a class="dropdown-item"
                     [routerLink]="'/'+routes.statisticsForCampaign({projectId: projectId}, {campaignId: campaign.id})"
                     [queryParams]="{campaignId: campaign.id}">
                    <i class="fa fa-eye me-2"></i>View report</a>
                  }
                  <a class="dropdown-item" (click)="deleteCampaign(campaign.id)">
                    <i class="fa fa-trash me-2"></i>Delete</a>
                  @if (['launch_queued', 'launch_scheduled', 'in-progress', 'launching', 'temporarily-failed'].includes(campaign.status)) {
                  <a class="dropdown-item" (click)="cancelLaunch(campaign.id)">
                    <i class="fa fa-times-circle me-2" aria-hidden="true"></i>Cancel Launch</a>
                  }
                  @if (['launched', 'launch_failed'].includes(campaign.status)) {
                  <a class="dropdown-item" (click)="reLaunch(campaign.id)">
                    <i class="fa fa-rocket me-2" aria-hidden="true"></i>Re-Launch</a>
                  }
                  @if (['draft', 'launch_failed'].includes(campaign.status) && campaign.email_from_name && campaign.email_reply_to && campaign.email_subject) {
                  <a class="dropdown-item"
                     (click)="launchCampaign(campaign.id)">
                    <i class="fa fa-rocket me-2" aria-hidden="true"></i>Launch Page</a>
                  }
                  <a class="dropdown-item" [href]="campaign.share_guide_url" target="_blank">
                    <i class="fa fa-book me-2" aria-hidden="true"></i>Setup Guide</a>
                  @if (campaign.integration_instruction_url) {
                  <a class="dropdown-item" [href]="campaign.integration_instruction_url" target="_blank">
                    <i class="fa fa-code me-2" aria-hidden="true"></i>Widget Instructions</a>
                  }
                </mat-menu>
              </div>
              <div class="no-label custom-margin w-100">
                <app-campaign-status [layoutType]="'card'"  [campaign]="campaign" [projectId]="projectId" [currentUser]="currentUser()" [subscribeSocket]="false"></app-campaign-status>
                <div class="no-label fw-bold cursor-pointer w-100 campaign-name" [routerLink]="'/'+routes.addInfluencers({projectId: projectId})"
                     [queryParams]="{campId: campaign.id}">
                  {{campaign.name}}
                  @if (campaign.created_by || campaign.updated_by) {
                    <app-info-popover container="body" info="{{getCampaignUpdateInfo(campaign)}}" ></app-info-popover>
                  }
                  <div class="card-date-section">
                    <small>{{campaign.code}}</small>
                    @if (campaign.launched_at && campaign.status === 'launched') {
                    <small
                           class="campaign-launch-history-link"
                           [class.cursor-pointer]="campaign.last_launched_at && currentUser()?.can('launchHistory', 'campaign')"
                           (click)="campaign.last_launched_at && currentUser()?.can('launchHistory', 'campaign') && openCampaignLaunchHistory(campaign, $event)">
                      - Launched {{campaign.launch_user ? 'by' : 'at'}} {{$safeNavigationMigration(campaign.launch_user?.first_name) | titlecase}} {{$safeNavigationMigration(campaign.launch_user?.last_name) | titlecase}} - {{smartDateFormat($safeNavigationMigration(campaign?.launched_at)) | tzDate : false : 'DD MMM, YYYY h:mm A'}}
                      @if (campaign.last_launched_at && currentUser()?.can('launchHistory', 'campaign')) {
                      <i
                         class="fa fa-history campaign-launch-history-icon" title="Launch History"></i>
                      }
                      @if (campaign.timezone || project()?.timezone) {
                      <app-info-popover container="body" info="{{getDateTimeBasedOnCampaign(campaign, project())}}" ></app-info-popover>
                      }
                    </small>
                    }
                    @if (!(campaign.launched_at && campaign.status === 'launched') && campaign.last_launched_at) {
                    <small
                           class="campaign-launch-history-link"
                           [class.cursor-pointer]="currentUser()?.can('launchHistory', 'campaign')"
                           (click)="currentUser()?.can('launchHistory', 'campaign') && openCampaignLaunchHistory(campaign, $event)">
                      - Previously launched at {{smartDateFormat($safeNavigationMigration(campaign?.last_launched_at))}}
                      @if (currentUser()?.can('launchHistory', 'campaign')) {
                      <i class="fa fa-history campaign-launch-history-icon" title="Launch History"></i>
                      }
                    </small>
                    }
                    @if (!(campaign.launched_at && campaign.status === 'launched') && !campaign.last_launched_at && campaign.status !== 'draft' && currentUser()?.can('launchHistory', 'campaign')) {
                    <small
                           class="campaign-launch-history-link cursor-pointer"
                           (click)="openCampaignLaunchHistory(campaign, $event)">
                      <i class="fa fa-history campaign-launch-history-icon" title="Launch History"></i>
                    </small>
                    }
                  </div>
                </div>
              </div>
              @if (campaign.email_subject) {
              <hr class="w-100">
              }
              @if (campaign.email_subject) {
              <div class="email-subject w-100 text-center">{{campaign.email_subject}}</div>
              }
              @if (campaign.sync_influencers_before_launch || campaign.sync_influencers_after_launch) {
              <div
                  class="campaign-api-sync w-100 text-center" data-label="API SYNC">
                <app-campaign-api-sync [campaign]="campaign"></app-campaign-api-sync>
              </div>
              }
              <div class="text-start custom-td" [routerLink]="'/'+routes.addInfluencers({projectId: projectId})"
                  [queryParams]="{campId: campaign.id}" data-label="INFLUENCERS">
                  <span>
                    {{campaign.influencers_count}}
                  </span>
              </div>
              <div class="text-start custom-td" data-label="CONVERSIONS">
                <span>
                  {{campaign.referrals}}
                </span>
              </div>
              <div class="text-start custom-td" title="{{getEmailSendProgressInfo(campaign)}}" data-label="OPEN RATE">
                <span>{{getEmailSendProgress(campaign)}}</span></div>
            </div>
          </ng-template>
        </app-sb-table>
      </div>
    </div>
</app-page-shell>
